<template>
  <section class="game-version-component" :class="{ selected: selected }">
    <div class="version">
      <vd-custom-icon v-if="version.icon" :name="version.icon" :active="selected" />
      <span v-else class="version-number">{{ version.historySeq }}</span>
      <span class="version-name">
        {{ version.isLive ? "Live Version" : version.name }}
        <span v-if="version.isLive" class="version-live-name">&nbsp;(version {{ version.name }})</span>
      </span>
    </div>
    <span class="version-date">{{ formattedDate }}</span>
  </section>
</template>

<script lang="ts">
import { parseJSON, format } from "date-fns";
import { defineComponent, computed, PropType } from "vue";

import { GameDisplayPageVersionFragment } from "@/graphql/generated-types";

export default defineComponent({
  name: "GameVersion",

  props: {
    version: {
      type: Object as PropType<GameDisplayPageVersionFragment>,
      required: true,
    },

    selected: Boolean,
  },

  setup(props) {
    const formattedDate = computed(() => {
      if (!props.version.publishedDate) {
        return undefined;
      }
      const dateParsed = parseJSON(props.version.publishedDate);
      return format(dateParsed, "d MMM yyyy");
    });

    return {
      formattedDate,
    };
  },
});
</script>

<style lang="scss">
:root {
  --voodootune-game-version-highlight-color: var(--voodootune-background-color);
}

.game-version-component {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $foggy-grey;

  cursor: pointer;
  height: 35px;
  padding: size("S");

  font-size: font("S");
  font-weight: 600;

  &:hover {
    background-color: var(--voodootune-game-version-highlight-color);
  }

  &.selected {
    background-color: var(--voodootune-game-version-highlight-color);
    color: $intense-blue;
  }

  .version {
    display: flex;
    align-items: center;

    @include medium-screen {
      max-width: 70%;
    }

    .version-number {
      color: var(--voodootune-accent-color);
      font-size: 10px;
      font-weight: 900;
      padding-right: size("XS");
      padding-left: size("XXS");
    }

    .version-name {
      letter-spacing: 1px;
      transition: text-stroke $animation-timing;

      @include medium-screen {
        @include ellipsis;
      }

      .version-live-name {
        font-size: font("XS");
        font-weight: 400;
        color: $grey;
      }
    }
  }

  .version-date {
    color: $grey;
    font-size: font("XS");
    font-weight: 400;
  }
}
</style>
